import mixpanel from "mixpanel-browser";

import { alert } from "../components/common/Alert";
import { getTempScribenoteFlask } from "../utils";
import { API_HEADERS } from "./utils";

const SCRIBENOTE_FLASK = getTempScribenoteFlask();

export async function instantiateOrgPortal() {
  fetch(`${SCRIBENOTE_FLASK}/create-org-portal-session`, {
    method: "post",
    headers: API_HEADERS.headers(),
    credentials: "include",
  })
    .then((response) => response.json())
    .then((data) => {
      const redirectUrl = data.redirect;
      window.location.href = redirectUrl;
    })
    .catch((error) => {
      alert(
        "error",
        `Failed to create organization portal session: ${error}`,
      );
    });
}

export async function instantiateCustomerPortal() {
  fetch(`${SCRIBENOTE_FLASK}/create-customer-portal-session`, {
    method: "post",
    headers: API_HEADERS.headers(),
    credentials: "include",
  })
    .then((response) => response.json())
    .then((data) => {
      const redirectUrl = data.redirect;
      window.location.href = redirectUrl;
    })
    .catch((error) => {
      alert(
        "error",
        `Failed to create customer portal session: ${error}`,
      );
    });
}

function postCheckout({
  endpoint,
  body,
  failureEvent,
  failureEventProps,
  errorAlertMessage,
  onError,
}) {
  return fetch(`${SCRIBENOTE_FLASK}${endpoint}`, {
    method: "POST",
    headers: API_HEADERS.headers(),
    body: JSON.stringify(body),
    credentials: "include",
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.error) {
        console.error(data.error);
        mixpanel.track(failureEvent, {
          error: data.error,
          ...failureEventProps,
        });
        alert("error", errorAlertMessage(data.error));
        onError?.(data.error);
      } else {
        window.location = data.sessionUrl;
      }
    })
    .catch((err) => {
      console.error(err);
      onError?.(err);
    });
}

export function handleSetup(returnUrl) {
  return postCheckout({
    endpoint: "/create-setup-session",
    body: { returnUrl },
    failureEvent: "Billing Setup Failed",
    errorAlertMessage: (e) => `Failed to create setup session: ${e}`,
  });
}

export function handleTreatPackCheckout({
  priceId,
  route = "/account?tab=companion",
  onError,
}) {
  return postCheckout({
    endpoint: "/create-treat-pack-checkout",
    body: {
      priceId,
      returnUrl: `${window.location.origin}${route}`,
    },
    failureEvent: "Treat Pack Checkout Failed",
    failureEventProps: { priceId },
    errorAlertMessage: (e) => e,
    onError,
  });
}

export function handleSubscribe({
  priceId,
  route = "/account",
  onError,
}) {
  return postCheckout({
    endpoint: "/create-checkout-session",
    body: {
      priceId,
      returnUrl: `${window.location.origin}${route}`,
    },
    failureEvent: "Upgrade Plan Failed",
    errorAlertMessage: (e) => e,
    onError,
  });
}

export function handleCompanionSubscribe({
  priceId,
  route = "/account?tab=companion",
  onError,
}) {
  return postCheckout({
    endpoint: "/create-companion-checkout-session",
    body: {
      priceId,
      returnUrl: `${window.location.origin}${route}`,
    },
    failureEvent: "Companion Subscribe Failed",
    failureEventProps: { priceId },
    errorAlertMessage: (e) => e,
    onError,
  });
}
